module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-17.69f6840c.png";